<template>
<div class="cs-reset-password">
    <div class="box">
        <div class="title">New Password</div>
            <b-form class="form-vertical login-form formV2" autocomplete="off">
                <gofix-form-input label="Email" v-model="$v.user.email.$model" type="email" required>
                    <template slot="gofixInput:text:after-desc">
                        <p class="desc">
                            <small v-if="$v.user.email.$error" class="clear-small label-error">Email doesn’t match</small>
                        </p>
                    </template>
                </gofix-form-input>
                <gofix-form-input label="New Password" v-model="$v.user.password.$model" :type="type" required>
                    <template slot="gofixInput:text:after-desc">
                        <p class="desc">
                            <small v-if="$v.user.password.$error" class="clear-small label-error">New Password doesn’t match</small>
                        </p>
                    </template>
                </gofix-form-input>
                <gofix-form-input label="Confirm New Password" v-model="$v.user.password_confirmation.$model" :type="type" required>
                    <template slot="gofixInput:text:after-desc">
                        <p class="desc">
                            <small v-if="$v.user.password_confirmation.$error" class="clear-small label-error">Confirm New Password doesn’t match</small>
                        </p>
                    </template>
                </gofix-form-input>
                <b-button @click="changePassword" :loading="isAction" type="button" variant="primary" class="submit btn pull-right"> Change </b-button>
            </b-form>
        </div>
        <b-toast id="toast-custom2" variant="danger" solid>
            <template #toast-title>
                <div class="d-flex flex-grow-1 align-items-baseline">
                <strong class="mr-auto">Notification!</strong>
                </div>
            </template>
            <div class="err-pwd-toast" v-if="errorMessage">
                <div v-html="errorMessage"></div>
            </div>
        </b-toast>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { required, sameAs, email } from 'vuelidate/lib/validators'
    import Loader from './Loader.vue';
    export default {
        name: 'ResetPasswordUser',
        components: {
            Loader
        },
        data () {
            return {
                user : {
                    email:null,
                    password : null,
                    password_confirmation:null,
                    token:this.$route.params.token
                },
                errorMessage:null,
                isAction : false,
                type : 'password',
                isLoading: false,
                timer: null,
                timer1:null
            }
        },
        mixins: [validationMixin],
        validations: {
            user: {
                email : {
                    required,
                    email
                },
                password : {
                    required
                },
                password_confirmation : {
                    sameAsPassword: sameAs("password"),
                    required
                }
            }
        },
        computed: {
           
        },
        mounted(){
            //this.$refs['modal-change-password'].show();
        },
        methods:{
            convertNewLine(str){
                return str.replace(/\n/g, '<br />');
            },
            async changePassword(){
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return false;
                }
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.isAction = true;
                this.errorMessage = null
                this.timer = setTimeout(async () => {
                    this.$store.dispatch(`AuthController/resetPassword`, this.user)
                    .then(response => {
                        if(response.data.status == 422){
                            this.errorMessage = this.convertNewLine(response.data.data.message);
                            this.$bvToast.show('toast-custom2');
                        }else{
                            this.$alertNotification(response.data.data.message, "success");
                            setTimeout(async () => {
                                this.$router.push('/login');
                            },2000)
                        }
                        this.isAction = false;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                }, 300);
            },
        }
    }
</script>